var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({color: _vm.sectionColour})},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.index)+" "),_c('ul',_vm._l((_vm.sectionErrors),function(field,i){return _c('li',{key:("err" + i)},[_vm._v(" "+_vm._s(field.error)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }